import type { GetCustomersResponse } from '@vy/api-definition';
import { GetCustomersResponseSchema } from '@vy/api-definition';
import type { PaginationInput } from '@vy/types';
import { ALL_ITEMS_PAGE_SIZE_CODE } from '@vy/types';
import { validateNotEmptyObject } from '@vy/utils';
import { useQuery } from 'react-query';
import { getPrivateApi } from '../../services/api';
import { queryKeys } from '../../services/query-key/query-keys';
import { CustomUseQueryOptions } from './requests-types/custom-use-query-options';

export function useAllCustomers(options?: CustomUseQueryOptions<GetCustomersResponse>) {
  const allCustomersQuery = useCustomers({
    ...options,
    page: 0,
    pageSize: ALL_ITEMS_PAGE_SIZE_CODE,
  });

  return allCustomersQuery;
}

function useCustomers({
  page,
  pageSize,
  ...options
}: PaginationInput & CustomUseQueryOptions<GetCustomersResponse>) {
  const customersQuery = useQuery(
    queryKeys.customer(page, pageSize),
    async () => {
      const privateApi = getPrivateApi();
      const getCustomersResponse = await privateApi.getCustomers({
        page,
        pageSize,
      });

      return GetCustomersResponseSchema.parse(getCustomersResponse);
    },
    { suspense: true, ...options },
  );

  validateNotEmptyObject(customersQuery.data, 'Customers');

  return customersQuery;
}
